import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20inviting%20product%20discovery%20scene%20with%20hands%20holding%20tablet%20showing%20colorful%20shopping%20interface%2C%20surrounded%20by%20carefully%20arranged%20fashion%20items%20sneakers%20and%20accessories%20in%20soft%20focus%20background%2C%20golden%20hour%20lighting%2C%20cozy%20retail%20inspiration%20mood%2C%20editorial%20lifestyle%20photography%2C%20rich%20amber%20and%20cream%20tones%2C%20sophisticated%20consumer%20experience%20aesthetic&width=1600&height=600&seq=cta-kakobuy-2026-v3&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          {t('cta.title')}
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          {t('cta.description')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <i className="ri-external-link-line"></i>
            {t('cta.button')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm border border-white/30 text-white rounded-full text-sm md:text-base font-semibold hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2"
          >
            <i className="ri-shopping-cart-line"></i>
            {t('hero.cta_kakobuy')}
          </a>
        </div>
      </div>
    </section>
  );
}